"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { cta as data } from "@/lib/data/platform-updates";

export function Details() {
  return (
    <Section id="details" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/4 right-1/3 h-80 w-80 rounded-full bg-[var(--color-cyan)] opacity-15 blur-[120px]" />
      </div>
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">Platform Details</span>
            <h2 className="mt-3">Built for Updates Excellence</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">
              Perception X2 delivers purpose-built capabilities refined through 15+ years of operational deployment
              across the most demanding environments. Every component is engineered for the specific requirements
              of Updates — from data ingestion through narrative deployment.
            </p>
          </div>
        </Reveal>
        <Reveal delay={200}>
          <div className="mt-12 grid sm:grid-cols-2 gap-5">
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-cyan) 12%, transparent)` }}>
              <h3 className="text-lg">Autonomous Operation</h3>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                The platform operates independently — scanning, analyzing, generating, deploying, and optimizing
                with minimal human intervention. Human operators set strategic objectives. The platform executes.
              </p>
            </div>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-crimson) 12%, transparent)` }}>
              <h3 className="text-lg">Verified Performance</h3>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                300-500% narrative penetration improvement. 95-98% organic authenticity. 99.9999% uptime.
                384x-1,416x faster crisis response. These are not theoretical maximums — they are sustained
                production averages.
              </p>
            </div>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-emerald) 12%, transparent)` }}>
              <h3 className="text-lg">Integrated Intelligence</h3>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                Four proprietary AI engines work as a unified pipeline. Insights from one engine inform the others.
                This integration creates compounding intelligence that standalone tools cannot achieve.
              </p>
            </div>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-purple) 12%, transparent)` }}>
              <h3 className="text-lg">Sovereign Infrastructure</h3>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                Every capability runs on proprietary infrastructure. Zero reliance on third-party cloud services,
                licensed APIs, or external data providers. Your perception data never traverses unsecured systems.
              </p>
            </div>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
